import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type GenerateLettersRequest = {
  collectionIssueIds: number[];
  letterTemplateId: number;
};

export type GenerateLettersResponse = {};

export const generateLetters = async (request: GenerateLettersRequest) => {
  await executeApiRequest(async () => {
    const response = await axios.post(`/reports/generateletters`, request, {
      responseType: "blob"
    });
    const blobData = new Blob([response.data]);
    const url = window.URL.createObjectURL(blobData);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "letters.zip");
    document.body.appendChild(link);
    link.click();

    return response;
  }, false);
};
